import { RefObject, useEffect } from "react";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { MOVE_EXPLORER_ITEM } from "@/common/sse-api-event-source-message-types";
import { ExplorerItem, ExplorerItems } from "@/types/types.ts";
import useExplorerItems from "@/common/hooks/useExplorerItems.ts";

function useMoveExplorerItem(eventSourceRef: RefObject<EventSource | null>) {
  const [, setExplorerItems] = useExplorerItems();

  // MOVE_EXPLORER_ITEM Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handleMoveExplorerItem = (e: MessageEvent) => {
      const { id, newIndex } = JSON.parse(e.data);

      setExplorerItems((prevItems: ExplorerItems) => {
        const itemsArray: ExplorerItem[] = Object.values(prevItems);
        const itemToMove = itemsArray.find(item => item.id === id);
        if (!itemToMove) {
          return prevItems;
        }

        const currentIndex = itemsArray.indexOf(itemToMove);

        itemsArray.splice(currentIndex, 1);
        itemsArray.splice(newIndex, 0, itemToMove);
        return itemsArray.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {} as ExplorerItems);
      });
    };

    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      MOVE_EXPLORER_ITEM,
      handleMoveExplorerItem,
    );

    return () => {
      removeListener();
    };
  }, [
    eventSourceRef,
    setExplorerItems
  ]);
}

export default useMoveExplorerItem;
